import dayjs from "./dayjs";
import { daysJsFormat, statusPrestationsValues, subStatus } from "./constants";
import { calculateTva } from "./helpersFunction";
import Decimal from "./decimal";

function findLastItemWithTva(bill) {
  for (let i = bill.costs.length - 1; i >= 0; i--) {
    const cost = bill.costs[i];

    const pres = bill.prestations[0]; // Assuming pres is the same for all costs

    let isCanceledClient =
      [statusPrestationsValues.cancelClient].includes(pres.status) ||
      ([subStatus.institution].includes(pres.subStatus) &&
        [statusPrestationsValues.cancel].includes(pres.status));
    let isCancelInterprete =
      [statusPrestationsValues.cancelInterprete].includes(pres.status) ||
      ([subStatus.interprete].includes(pres.subStatus) &&
        [statusPrestationsValues.cancel].includes(pres.status));

    if (bill.type === "multiple") {
      isCanceledClient = false;
      isCancelInterprete = false;
    }


    let tva = 0;

    if (cost.type !== "cancel" && !isCanceledClient && !isCancelInterprete) {
      tva = 1;
    }

    if (tva !== 0) {
      return i;
    }
  }
  return null; // Return null if no item with non-zero TVA is found
}

export function createXMLString({ bills }) {
    let indexCorrection = 0
  // Example XML String; you should generate this based on your data
  const xmlContent = `<AbaConnectContainer>
  <TaskCount>1</TaskCount>
  <Task>
     <Parameter>
      <Application>DEBI</Application>
      <Id>Belege</Id>
      <MapId>AbaDefault</MapId>
      <Version>2021.00</Version>
    </Parameter>
    ${bills
      .map(bill => {
        let tvas = [];
        let lastItemWithTva = findLastItemWithTva(bill);

        let date = null;
        let pres = bill.prestations[0];
        let refsText = "";

        if (bill.type === "unique") {
          refsText = `Prestation ${pres.reference}`;
          date = pres.finalStartDate;
        } else {
          refsText = `Facture groupée`;
          date = dayjs()
            .year(bill.prestationsRef.year)
            .month(bill.prestationsRef.month - 1)
            .endOf("month")
            .format();
        }
        
    

        let stringReturned = `<Transaction id="${bill._id}">
      <Document mode='SAVE'>
        <DocumentCode>R</DocumentCode>
        <!-- numero client comptabilité client -->
        <CustomerNumber>158</CustomerNumber>
        <!-- Numéro de la facture-->
        <Number>${bill.bill_number}</Number> <!-- dynamic -->
        <Text>${refsText}</Text>
        <AccountReceivableDate>
        ${dayjs(date).format(daysJsFormat.abacus)}
        </AccountReceivableDate>
        <Currency>CHF</Currency>
        <Amount>${
          bill.amount
        }</Amount> <!-- Montant TTC à payer -->  <!-- dynamic -->
        <KeyAmount>${
          bill.amount
        }</KeyAmount> <!-- Montant TTC à payer -->  <!-- dynamic -->
        <AmountOI>${
          bill.amount
        }</AmountOI> <!-- Montant TTC à payer -->  <!-- dynamic -->
        <KeyAmountOI>${
          bill.amount
        }</KeyAmountOI> <!-- Montant TTC à payer -->  <!-- dynamic -->
        <ReminderProcedure>NORM</ReminderProcedure>
        <PaymentOrderProcedure>1</PaymentOrderProcedure>
        <PaymentReferenceLineType>QR</PaymentReferenceLineType>
        <!-- Numéro de référence facturation -->
        <PaymentReferenceLine>${bill.reference.replace(
          / /g,
          "",
        )}</PaymentReferenceLine>  <!-- dynamic -->
        <CollectiveAccount>1100</CollectiveAccount>
        <NoTax>false</NoTax>
        <StatusIdentification>1</StatusIdentification>
        <UstEUValid>false</UstEUValid>
        ${bill.costs
          .map((cost, index ) => {
            let isCanceledClient =
              [statusPrestationsValues.cancelClient].includes(pres.status) ||
              ([subStatus.institution].includes(pres.subStatus) &&
                [statusPrestationsValues.cancel].includes(pres.status));

            let isCancelInterprete =
              [statusPrestationsValues.cancelInterprete].includes(
                pres.status,
              ) ||
              ([subStatus.interprete].includes(pres.subStatus) &&
                [statusPrestationsValues.cancel].includes(pres.status));

            if (bill.type === "multiple") {
              isCanceledClient = false;
              isCancelInterprete = false;
            }

            let tva = 0;
            

            if (
              cost.type !== "cancel" &&
              !isCanceledClient &&
              !isCancelInterprete
            ) {
              tva = calculateTva({
                amount: new Decimal(cost.amount).toNumber().arrondi2Decimal(),
                year: bill.prestationsRef.year,
              }).tvaAmount;
            }
            
            

            let creditAccount = 0;
            let taxCode = 300;

            if (
              (isCanceledClient || isCancelInterprete) &&
              bill.type === "unique"
            ) {
              taxCode = 301;
              tva = 0;
              creditAccount = 3815;
            } else {
              switch (cost.type) {
                case "travel":
                  creditAccount = 3807;
                  break;
                case "cancel":
                  taxCode = 301;
                  tva = 0;
                  creditAccount = 3815;
                  break;
                default:
                  creditAccount = 3800;
                  break;
              }
            }
            tvas.push(tva);
            // Correct TVA
            if (tva !== 0 && lastItemWithTva === index ) {
              let sums = tvas.reduce((a, b) => a + b, 0);
              let roundedSums = Number(sums.toFixed(2));
              if (roundedSums !== bill.costParams.tvaAmount) {
                  const decimalDiff = new Decimal(bill.costParams.tvaAmount).minus(roundedSums);
                tva += decimalDiff.toNumber().arrondi2Decimal()
               
              }
            }
              let rounded = new Decimal(cost.amount).toNumber().toFixed(2);
              let amount = new Decimal(rounded).plus(tva)
              
            return `<LineItem mode='SAVE'>
            <Number>${index + 1  }</Number>
            <Amount>${amount}</Amount> <!-- dynamic -->
            <KeyAmount>${amount}</KeyAmount> <!-- dynamic -->
            <CreditAccount>${creditAccount}</CreditAccount>
            <CreditCostCentre1>2100</CreditCostCentre1>
            <TaxMethod>1</TaxMethod>
            <TaxCode>${taxCode}</TaxCode>
            <TaxIncluded>2</TaxIncluded>
            <!-- date de la prestation -->
            ${
              date !== null
                ? `<TaxDateValidFrom>
                  ${dayjs(date).format(daysJsFormat.abacus)}
                </TaxDateValidFrom>`
                : ""
            }
            <!-- dynamic -->
            <TaxAmount>${tva !== 0 ? `-${tva}` : 0}</TaxAmount>
            <KeyTaxAmount>${tva !== 0 ? `-${tva}` : 0}</KeyTaxAmount>
            <Text>${cost.title}</Text> <!-- dynamic -->
            <TargetDivision>false</TargetDivision>
            <BookingAsset>false</BookingAsset>
          </LineItem>`;
          })
          .join("")}
        ${
          bill.costParams.roundCorrection !== 0
            ? `
        <LineItem mode='SAVE'>
            <Number>${bill.costs.length + 1 }</Number>
            <Amount>${bill.costParams.roundCorrection}</Amount> <!-- dynamic -->
            <KeyAmount>${
              bill.costParams.roundCorrection
            }</KeyAmount> <!-- dynamic -->
            <CreditAccount>${3810}</CreditAccount>
            <CreditCostCentre1>2100</CreditCostCentre1>
            <TaxMethod>1</TaxMethod>
            <TaxCode>301</TaxCode>
            <TaxIncluded>2</TaxIncluded>
            <!-- date de la prestation -->
            <TaxDateValidFrom>${dayjs(date).format(
              daysJsFormat.abacus,
            )}</TaxDateValidFrom> <!-- dynamic -->
            <TaxAmount>0</TaxAmount>
            <KeyTaxAmount>0</KeyTaxAmount>
            <Text>${"Correction arrondi"}</Text> <!-- dynamic -->
            <TargetDivision>false</TargetDivision>
            <BookingAsset>false</BookingAsset>
          </LineItem>`
            : ""
        }
        <PaymentTerm mode='SAVE'>
          <Number>${bill.costs.length +
            1 + 
            (bill.costParams.roundCorrection !== 0 ? 1 : 0)}</Number>
          <CopyFromTable>true</CopyFromTable>
          <Type>0</Type>
          <PartialPaymentMonthly>false</PartialPaymentMonthly>
          <NumberOfPartialPayments>0</NumberOfPartialPayments>
          <DeadlineInDays>0</DeadlineInDays>
          <!-- Numéro de référence facturation -->
          <PaymentReferenceLine>${bill.reference.replace(
            / /g,
            "",
          )}</PaymentReferenceLine> <!-- dynamic -->
        </PaymentTerm>
      </Document>
    </Transaction>`;
          return stringReturned;
      })
      .join("")}
  </Task>
</AbaConnectContainer>`;

  return `${"<?xml version='1.0' encoding='UTF-8'?>"}${xmlContent}`;
}
export function createXMLWages({ wages, month, year }) {
  // total heure normal
  // total heures tel
  //  total KMS
  //


  // Example XML String; you should generate this based on your data
  const xmlContent = `<AbaConnectContainer>
  <TaskCount>1</TaskCount>
  <Task>
     <Parameter>
      <Application>LOHN</Application>
      <Id>HierarchyPreEntry</Id>
      <MapId>AbaDefault</MapId>
      <Version>2019.00</Version>
    </Parameter>${wages.map((wage) => {const date = dayjs().year(year).month(month - 1).endOf("month").format(daysJsFormat.abacus); return `${wage.type === 'person' ? ` 
           <Transaction id='${wage.entryNumber}'> 
                <PreEntry mode='SAVE'>
                    <!-- numéro employé -->
                    <EmployeeNumber>${wage.nLoga}</EmployeeNumber>
                    <PeriodDate>${date}</PeriodDate>
                    <PeriodNumber>${month}</PeriodNumber>
                    <PayrollType>1108</PayrollType> <!-- 1108 Salaire horaire en présence AVIC  -->
                    <Amount>${wage.amount.toFixed(6)}</Amount> <!-- nombre total d’heure à payer -->
                    <AmountID/>
                    <MutationCodeAmount>true</MutationCodeAmount>
                    <Factor>0</Factor>
                    <FactorID/>
                    <MutationCodeFactor>false</MutationCodeFactor>
                    <Operator>0</Operator>
                    <EntryNumber>${wage.entryNumber}</EntryNumber>
                    <Recurring>false</Recurring>
                    <CostCentre1>2100</CostCentre1>
                </PreEntry>
           </Transaction>`:""}${wage.type === 'tel' ? `
           <Transaction id='${wage.entryNumber}'> 
                <PreEntry mode='SAVE'>
                    <EmployeeNumber>${wage.nLoga}</EmployeeNumber>
                    <PeriodDate>${date}</PeriodDate>
                    <PeriodNumber>${month}</PeriodNumber>
                    <PayrollType>1109</PayrollType> <!-- 1109 Salaire horaire téléphone AVIC  -->
                    <Amount>${wage.amount.toFixed(6)}</Amount> <!-- nombre total de minutes à payer -->
                    <AmountID/>
                    <MutationCodeAmount>true</MutationCodeAmount>
                    <Factor>0</Factor>
                    <FactorID/>
                    <MutationCodeFactor>false</MutationCodeFactor>
                    <Operator>0</Operator>
                    <EntryNumber>${wage.entryNumber}</EntryNumber>
                    <Recurring>false</Recurring>
                    <CostCentre1>2100</CostCentre1>
                </PreEntry>
           </Transaction>`:""}${wage.type === 'travel' ?`
           <Transaction id='${wage.entryNumber}'> 
                <PreEntry mode='SAVE'>
                    <EmployeeNumber>${wage.nLoga}</EmployeeNumber>
                    <PeriodDate>${date}</PeriodDate>
                    <PeriodNumber>${month}</PeriodNumber>
                    <PayrollType>5200</PayrollType> <!-- 5200 Salaire KM AVIC  -->
                    <Amount>${wage.amount.toFixed(6)}</Amount> <!-- nombre total de  à payer -->
                    <AmountID/>
                    <MutationCodeAmount>true</MutationCodeAmount>
                    <Factor>0</Factor>
                    <FactorID/>
                    <MutationCodeFactor>false</MutationCodeFactor>
                    <Operator>0</Operator>
                    <EntryNumber>${wage.entryNumber}</EntryNumber>
                    <Recurring>false</Recurring>
                    <CostCentre1>2100</CostCentre1>               
                </PreEntry>
           </Transaction>`:""}`;}).join("")}
  </Task>
</AbaConnectContainer>`;
  return `${"<?xml version='1.0' encoding='UTF-8'?>"}${xmlContent}`;
}


export function jsonToCsv(jsonData) {
    // Check if jsonData is an array and has at least one object
    if (!Array.isArray(jsonData) || jsonData.length === 0) {
        return '';
    }

    // Extract headers from the first object
    const headers = Object.keys(jsonData[0]);
    const csvRows = [];

    // Add headers row
    csvRows.push(headers.join(','));

    // Add data rows
    for (const row of jsonData) {
        const values = headers.map(header => {
            const escaped = ('' + row[header]).replace(/"/g, '""'); // Escape double quotes
            return `"${escaped}"`; // Wrap each value in double quotes
        });
        csvRows.push(values.join(','));
    }

    // Join all rows with newline character
    return csvRows.join('\n');
}
export function downloadStringFileXml_CSV(xmlString, fileName, type = "application/xml") {
  const blob = new Blob([xmlString], { type: type});
  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
}
